<script>
import PixelBase from "@/components/tools/PixelBase.vue";
export default {
  extends: PixelBase,
  data() {
    return {
      title: "Facebook Ads",
      pixelType: "facebook"
    };
  }
};
</script>
